import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DefaultService } from '@common/references/default.service';
import { BasicForm } from '@shared/components/classes/basic.form';
import { UtilityProviderType } from '@modules/settings/utility-types/utility-types.interfaces';
import {UtilityProviderTypesService} from '@modules/settings/utility-types/utility-provider-types.service';
import {TranslatePipe} from '@ngx-translate/core';
import {InputValidatorDirective} from '@common/directive/input-validator.directive';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { UnitTypes } from '@shared/enums/UnitTypes.enum';
import { UtilityProvidersService } from '@modules/settings/utility-providers/utility-providers.service';
import { ButtonModule } from "@primeng/button";



@Component({
  selector: 'app-utility-types-form',
  templateUrl: './utility-types-form.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputValidatorDirective,
    AutocompleteComponent,
    NgSelectComponent,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,
    ButtonModule,
  ],
  styleUrls: ['./utility-types-form.component.scss']
})
export class UtilityTypesFormComponent extends BasicForm<UtilityProviderType> {
  _defaultService: DefaultService<UtilityProviderType> = inject(UtilityProviderTypesService);
  form: FormGroup;
  unitTypes: UnitTypes[] = [UnitTypes.COLD_WATER, UnitTypes.WARM_WATER, UnitTypes.HEATING]

  utilityProvidersService = inject(UtilityProvidersService);

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      type: ['', [Validators.required]],
      utilityProviderId: ['', [Validators.required]],
    });
  }

  patchResponseData(response: any) {
    response.utilityProviderId = response?.utilityProvider?.id ?? response.utilityProviderId;
    super.patchResponseData(response);
  }
}
